import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api, { apiError } from '../lib/api';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';

/* Dialog "Ambil Orderan" (tandai barang sudah diambil customer + jaminan).
   Dipakai di Pemantauan, Order Sewa, dan Detail Order — dulu hanya ada di
   Pemantauan, sehingga staf yang bekerja dari Order Sewa tidak punya tombolnya. */

export const PICKUP_JAMINAN = [
  { value: 'titip_ktp', label: 'Titip KTP' },
  { value: 'kirim_wa', label: 'Kirim WA' },
  { value: 'tidak_ada', label: 'Tanpa Jaminan' },
];

export function PickupDialog({ tx, open, onClose, onDone }) {
  const [ktpType, setKtpType] = useState('tidak_ada');
  const [ktpName, setKtpName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open || !tx) return;
    setKtpType(tx.ktp_type || (tx.ktp ? 'titip_ktp' : 'tidak_ada'));
    setKtpName(tx.ktp_name || tx.ktp || '');
    setSaving(false);
  }, [open, tx?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const simpan = async () => {
    if (ktpType === 'titip_ktp' && !ktpName.trim()) return toast.error('Isi nama sesuai KTP yang dititipkan');
    setSaving(true);
    try {
      await api.post(`/transactions/${tx.id}/pickup`, { ktp_type: ktpType, ktp_name: ktpName.trim() });
      toast.success(`Order ${tx.transaction_number} diambil — masuk Sedang Disewa`);
      onClose?.();
      onDone?.(tx);
    } catch (err) {
      toast.error(apiError(err));
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!open} onOpenChange={(v) => { if (!v) onClose?.(); }}>
      <DialogContent data-testid="monitor-pickup-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-brown-dark">Ambil Orderan</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-mocha">
          Barang order <b>{tx?.transaction_number}</b> ({tx?.customer_name}) diambil customer.
          Order akan otomatis pindah ke <b>Sedang Disewa</b>.
        </p>
        <div>
          <label className="text-xs font-semibold uppercase tracking-wider text-mocha">Jaminan</label>
          <select
            data-testid="pickup-jaminan-select"
            value={ktpType}
            onChange={(e) => setKtpType(e.target.value)}
            className="mt-1.5 w-full rounded-xl border border-input bg-ivory/50 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-brown/30"
          >
            {PICKUP_JAMINAN.map((j) => <option key={j.value} value={j.value}>{j.label}</option>)}
          </select>
        </div>
        {ktpType === 'titip_ktp' && (
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-mocha">Nama di KTP</label>
            <input
              data-testid="pickup-ktp-name-input"
              value={ktpName}
              onChange={(e) => setKtpName(e.target.value)}
              placeholder="Nama sesuai KTP yang dititipkan"
              className="mt-1.5 w-full rounded-xl border border-input bg-ivory/50 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-brown/30"
            />
          </div>
        )}
        <DialogFooter className="gap-2">
          <button
            data-testid="monitor-pickup-cancel"
            onClick={() => onClose?.()}
            className="rounded-xl border border-border px-4 py-2.5 text-sm font-semibold text-mocha hover:bg-ivory"
          >
            Batal
          </button>
          <button
            data-testid="monitor-pickup-confirm"
            onClick={simpan}
            disabled={saving}
            className="rounded-xl bg-brown text-white px-4 py-2.5 text-sm font-bold hover:bg-brown-med disabled:opacity-60"
          >
            {saving ? 'Menyimpan…' : 'Konfirmasi Ambil'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
